/**
 * Product ilist rows may return `category` as a string ("lotion"), nested
 * `{ name }`, or use `category_name`. Nested API payloads (e.g. productBalance)
 * often only send `category_id` — pass `categoryNamesById` (Map or plain object)
 * to resolve the label.
 */
export function productCategoryLabelFromRow(row, categoryNamesById) {
  if (!row || typeof row !== 'object') return '—';
  const c = row.category;
  if (typeof c === 'string') {
    const t = c.trim();
    return t || '—';
  }
  if (c != null && typeof c === 'object') {
    const n = c.name ?? c.title;
    if (n != null && String(n).trim() !== '') return String(n).trim();
  }
  if (row.category_name != null && String(row.category_name).trim() !== '') {
    return String(row.category_name).trim();
  }
  if (
    row.category_id != null &&
    row.category_id !== '' &&
    categoryNamesById != null
  ) {
    const id = Number(row.category_id);
    if (!Number.isNaN(id)) {
      const resolved =
        categoryNamesById instanceof Map
          ? categoryNamesById.get(id)
          : categoryNamesById[id] ?? categoryNamesById[String(id)];
      if (resolved != null && String(resolved).trim() !== '') {
        return String(resolved).trim();
      }
    }
  }
  return '—';
}
